import type { InstitutionTheme } from '../types';
import { sjccColors } from './colors';

// San José City College institutional theme (W54 Worker J, S3).
//
// Brand strings from the college's own style guide ("San José City College", second
// reference "SJCC"); the student portal is Ellucian Colleague "Self Service" (the catalog's
// course-information keys: "Colleague Self-Service"; site nav "Single Sign On
// (Self Service/Canvas)"). Colors per ./colors.ts (Primary Purple + Accent Gold, from
// sjcc.edu/marketing/brand-style-guide.aspx).
//
// Example course codes are the three code SHAPES the S0 probe walk found
// (onboarding/sjcc/probes/course_index_s0.json): MATH 013 (zero-padded local — the
// canonical form, never "MATH 13"), ENGL C1000 (Common Course Number, printed in the C
// form), BIOL 004A (letter-suffixed, zero-padded). First entry is the primary example.
export const sjccTheme: InstitutionTheme = {
  slug: 'sjcc',
  universityName: 'San José City College',
  universityShortName: 'SJCC',
  registrationPortalName: 'Self Service',
  exampleCourseCodes: ['MATH 013', 'ENGL C1000', 'BIOL 004A'],
  colors: sjccColors,
};
